module.exports = __webpack_public_path__ + "images/emoji/nose.13054fc573435debe4a1.png";